import { LicenseModuleSummary } from "@/model/data/License/LicenseModuleSummary";
import { LicenseState } from "./state";

export default {
    getAvailableLicenses: (state: LicenseState) => (module) => {
        if (state.licensesDataSummaryLocal.filter((l: LicenseModuleSummary) => l.module == module).length > 0)
            return state.licensesDataSummaryLocal.filter((l: LicenseModuleSummary) => l.module == module)[0].availableLicenses;
        else return 0;
    },
};
